import { render, staticRenderFns } from "./SurveySubmissions.vue?vue&type=template&id=c20d3884&scoped=true"
import script from "./SurveySubmissions.vue?vue&type=script&lang=js"
export * from "./SurveySubmissions.vue?vue&type=script&lang=js"
import style0 from "./SurveySubmissions.vue?vue&type=style&index=0&id=c20d3884&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c20d3884",
  null
  
)

export default component.exports